/**
 * Email validation function
 * I stole this regex from here: https://mailtrap.io/blog/angular-email-validation/
 */
export function emailAddressIsValid(candidate: string): boolean {
  return !!candidate.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,30}$/)
}
